import { render, staticRenderFns } from "./EduCreateExampaperMain.vue?vue&type=template&id=7d08b10e&scoped=true&"
import script from "./EduCreateExampaperMain.vue?vue&type=script&lang=js&"
export * from "./EduCreateExampaperMain.vue?vue&type=script&lang=js&"
import style0 from "./EduCreateExampaperMain.vue?vue&type=style&index=0&id=7d08b10e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08b10e",
  null
  
)

export default component.exports